import React from 'react';
import { Form } from 'react-bootstrap';
import { InputFieldState } from '../types';

/**
 * SubmissionDateFormコンポーネント用のPropsです。
 * @interface SubmissionDateFormProps
 */
interface SubmissionDateFormProps {

  /**
   * 提出日
   * @type {InputFieldState}
   * @memberof SubmissionDateFormProps
   */
  date: InputFieldState;

  /**
   * 提出日を設定する関数
   * @memberof SubmissionDateFormProps
   */
  onChange: (date: InputFieldState) => void;
  
}

/**
 * 提出日フォームのコンポーネントです。
 * @param {string} props.date - 表示する提出日
 * @param {function} props.onChange - 提出日が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 提出日フォームのJSX要素
 */
const SubmissionDateForm: React.FC<SubmissionDateFormProps> = ({ date, onChange }) => {

  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 入力された識別番号を整形し、onChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onChange({
      value: value,
      errorMessage: value ? '' : '提出日が入力されていません。'
    });
  };

  return (
    <Form.Group className="mb-3 row" controlId="formDate">
      <Form.Label className="col-lg-2 col-12 d-flex align-items-center">
        提出日
        <span className="text-small text-danger ms-3">※必須</span>
      </Form.Label>
      <div className="col-lg-10 col-12">
        <Form.Control
          type="date"
          className="form-check-inline"
          value={date.value}
          onChange={handleChange}
          isInvalid={date.errorMessage !== ''}
        />
        {date.errorMessage !== '' ? <div className="text-end text-danger small">{date.errorMessage}</div> : ''}
      </div>
    </Form.Group>
  );
}

export default SubmissionDateForm;